import FixedTop from './components/FixedTop';
import Header from './components/Header';
import Mountain from './components/Mountain';
import HowTo from './components/HowTo';
import FAQs from './components/FAQs';
import Youtube from './components/Youtube';

function App() {
  const competitionEnded = true;

  return (
    <div id="body-wrapper">
      {competitionEnded && <FixedTop />}
      <Header />
      <Mountain />
      <HowTo competitionEnded={competitionEnded} />
      <FAQs angleBottomEdge={true} />
      <Youtube playlistID="PLTBLax1DE161Y9RsiiZXOj3zZIMQDo3w1" />
    </div>
  );
}

export default App;
